import type { components } from '@feedfm/clips-services-api';
import { Box } from '@mui/material';
import * as styles from './Rating.styles';

type Collection = components['schemas']['Collection'];
type Rating = Collection['rating'];

const RATING_LABELS: Record<Exclude<Rating, 'unknown'>, string> = {
  G: 'Safe',
  PG: 'Mild',
  'PG-13': 'Teen',
  R: 'Adult',
  NC17: 'Extreme',
};

export interface RatingProps {
  rating: Rating;
}

export const Rating = ({ rating }: RatingProps) => {
  if (!rating || rating === 'unknown') {
    return null;
  }

  return <Box sx={styles.pill}>{RATING_LABELS[rating]}</Box>;
};
